module.exports = __webpack_public_path__ + "img/logo.7663e34c.svg";